<template>
  <el-menu mode="horizontal" :default-active="headerActiveName"
           @select="handleMenuSelect" class="headerMenu" :router="false">
    <template v-for="(menu, menuIndex) in userMenus">
      <el-menu-item :index="menu.path" :route="{path: menu.path, query: {menuid: menu.menuid, doctid: menu.doctid }}">
        <span sloat="title">{{menu.title}}</span>
      </el-menu-item>
      <!-- <el-menu-item v-if="userMenus.length === (menuIndex+1)" index="/bbzx" :route="{path: '/bbzx', query: {}}">
        <span sloat="title">报表中心</span>
      </el-menu-item> -->
    </template>
    <el-dialog :show-close="false" :close-on-press-escape="false" :close-on-click-modal="false" @close="close" title="温馨提示：尊敬的用户，您的登录密码是平台初始值，为保证信息安全，请您修改密码" :visible.sync="dialogVisible" width="50%">
      <div>
        <el-form ref="selectrow" label-width="110px" class="fs2em">
          <!--<el-form-item label="用户名">-->
            <!--<span>{{$store.getters.loginUser.username}}-{{$store.getters.loginUser.usermobile}}</span>-->
          <!--</el-form-item>-->
          <!--<el-form-item label="原密码" verify required >-->
            <!--<el-input type="password"  v-model="userpwd"></el-input>-->
          <!--</el-form-item>-->
          <el-form-item label="新密码" verify required >
            <el-input type="password"  v-model="userpwd1"></el-input>
            <div style="color: red">新密码要求是数字和字符的结合，不能少于8位数!</div>
          </el-form-item>
          <el-form-item label="确认密码" verify required >
            <el-input type="password"  v-model="userpwd2"></el-input>
          </el-form-item>
          <el-form-item label="验证码" verify required >
            <div class="row">
              <div class="value"><el-input placeholder="请输入手机验证码" v-model="yzm" clearable></el-input></div>
              <div class="yzmbtn" :class="{gray: sendFlag}" @click="getsms">
                <sec-count-down v-if="sendFlag" @stop="stop">秒后获取</sec-count-down>
                <span  v-else style="color: blue;cursor: pointer;">发送验证码</span>
              </div>
            </div>
          </el-form-item>
          <el-form-item label="" verify required >
            <el-button @click="onSubmit">确定</el-button>
            <el-button @click="exist">退出</el-button>
          </el-form-item>
        </el-form>
      </div>
    </el-dialog>
  </el-menu>
</template>
<script>
  import menuMixin from '../../components/mixin/menu'
  import request from '@/utils/request'
  import Md5 from '../../assets/js/md5'
  import ElButton from "../../../node_modules/element-ui/packages/button/src/button.vue";
  import config from '../../assets/config'
  import SecCountDown from '../common/secCountDown'
  export default {
    name: 'vgheader',
    mixins: [
      menuMixin
    ],
    components: {ElButton, SecCountDown},
    data(){
      return{
        yzm: '',
        yzmToken: '',
        dialogTitle: '',
        dialogVisible: false,
        userpwd: '',
        userpwd1: '',
        userpwd2: '',
        sendFlag: false,
        isDisabledBtn: false,
        dialogVisible: false,
      }
    },
    created () {
      if (this.headerActiveName) {
        this.handleMenuSelect(this.headerActiveName, '')
      }
      let userpwd = Md5.md5(this.$store.getters.loginUser.usermobile.slice(this.$store.getters.loginUser.usermobile.length - 6))
      console.log(userpwd)
      if (userpwd === this.$store.getters.loginUser.userpassword) {
        this.dialogVisible = true
      }
    },
    computed: {
      userMenus () {
        return this.$store.getters.userMenus
      },
      headerActiveName() {
        return this.$store.getters.headerActiveName
      }
    },
    mounted () {
      // this.$store.commit('set_children_menus', [])
      // if (this.userMenus.length > 0) {
      //   this.$store.commit('set_children_menus', this.userMenus[0])
      // }
      // let children = this.userMenus.find(item => {return item.path === to.path})
      // console.log(this.userMenus)
    },
    watch: {
      async $route (to, from) {
        console.log(to, '---')
        let that = this
        let firstPath = new Set()
        this.userMenus.map(item => {
          firstPath.add(item.path)
        })
        if (firstPath.has(to.path)) {
          let children = this.userMenus.find(item => {return item.path === to.path})
          that.$store.commit('set_children_menus', children)
          let data = await request({
            method: 'get',
            url: '/kfgl/menu/getReportsByMenuUrl',
            params: {url: to.path.substr(1)}
          })
          let reportsMenus = data.map(item => {
            return {
              reportname: item.reportname,
              reportid: item.reportid,
              path: to.path
            }
          })
          that.$store.commit('set_reports_menus', reportsMenus)
        }
      }
    },
    methods: {
      async handleMenuSelect(key, keyPath) {
        // if (key.substr(1) === 'bbzx') {
        //   let data = await request({
        //     method: 'get',
        //     url: '/kfgl/menu/getReportTree',
        //     params: {comid: this.$store.getters.loginUser.comid,userid: this.$store.getters.loginUser.userid}
        //   })
        //   let reportsMenus = data.list
        //   this.$store.commit('set_children_menus', [])
        //   this.$store.commit('set_reports_menus', reportsMenus)
        // } else {
          let children = this.userMenus.find(item => {return item.path === key})
          this.$store.commit('set_children_menus', children)
          this.$store.commit('set_reports_menus', [])
        // }
        this.$store.commit('set_header_active_name', key)
      },
      async exist () {
        this.$confirm('确定退出登录吗?', '退出登录', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          // request({
          //   method: 'post',
          //   url: '/token/setCache',
          //   data: {key: this.$store.state.user.loginUser.cacheToken}
          // }).then (() => {
          //   let cacheToken = this.$store.state.user.loginUser.cacheToken
          //   this.$store.commit('login_out')
          //   location.href = `${config.webUrl}/#/login?t=${cacheToken}`
          // })
          let local = window.localStorage
          local.clear()
          this.$store.commit('login_out')
          location.href = `${config.webUrl}/#/login?t=ttHn2WsPOQ2QrMHrhlksf`
        })
        
      },
      async getsms () {
        if (this.isDisabledBtn) {
          return
        }
        let res = await request({
          url: '/sms/send',
          method: 'get',
          params: {type: '1', tel: this.$store.getters.loginUser.usermobile}
        })
        this.sendFlag = true
        this.isDisabledBtn = true
        this.yzmToken = res.data
        if (res.issuccess) {
          this.$message.success('验证码获取成功')
        } else {
          this.isDisabledBtn = false
          this.sendFlag = false
          this.$message.error({
            message: '获取验证码失败，请30秒后再重新获取',
            type: "warning"
          })
        }
      },
      stop () {
        this.isDisabledBtn = false
        this.sendFlag = false
      },
      async onSubmit () {
        var reg = /^(?![0-9]+$)(?![a-zA-Z]+$)[0-9A-Za-z!@+-=#*$%_]{8,}$/
        if (!this.userpwd1) {
          this.$message.warning('请录入新密码')
          return
        } else if (!reg.test(this.userpwd1)) {
          this.$message.warning('新密码要求是数字和字符的结合，不能少于8位数!')
          return
        } else if (this.userpwd2!==this.userpwd1) {
          this.$message.warning('新密码与确认密码必须一致')
          return
        }
        let data = await request ({
          url: '/xtgl/user/changePwd',
          method: 'post',
          data: {
            yzm: this.yzm,
            yzmToken: this.yzmToken,
            usercode: this.$store.getters.loginUser.usercode,
            usermobile: this.$store.getters.loginUser.usermobile,
            username: this.$store.getters.loginUser.username,
            // oldpassword: Md5.md5(this.userpwd),
            userpassword: Md5.md5(this.userpwd2),
            userid: this.$store.getters.loginUser.userid
          }
        })
        if (data.issuccess === 1) {
          this.$message.success(data.msg)
          setTimeout(() => {
            this.exist()
          }, 1500)
        } else {
          this.$message.warning(data.msg)
        }
      },
      close () {
        this.dialogVisible = true
        this.$alert('尊敬的用户，您的登录密码是平台初始值，为保证信息安全，请您修改密码', '温馨提示')
        return
      },
    }
  }
</script>
<style lang="scss">
.headerMenu{
  display: flex;
  align-items: center;
  text-align: left;
  .el-menu-item {
    height: 35px !important;
    line-height: 35px !important;
    width: 100px;
    font-size: 15px;
    margin-right: 5px;
    span {
      color: #333;
      font-weight: bold
    }
  }
  .el-menu-item:hover {
    background: #f36621 !important;
    span {
      color: #fff !important;
    }
  }
  .is-active {
    span {
      color: #fff !important;
    }
  }
}

</style>
